// Internal Imports
import { sendEventToGA } from '../../../utils/googleAnalytics.js';
import { trackPageEvent } from '../../../utils/tracking.js';

// Local Functions
const makeFlagLinkOnClick =
  ({ flagType, pageTrackingData, url }) =>
  () => {
    sendEventToGA(flagType);
    trackPageEvent({
      cta_placement: 'flags',
      link_url: url,
      name: 'magazine_page:cta_clicked',
      version: 1,
      ...pageTrackingData,
    });
  };

// Module Exports
export { makeFlagLinkOnClick };
